import "./sprinkles.css.ts.vanilla.js";
import "./fixed-footer-layout.css.ts.vanilla.js";
var v = "p5j8j58", a = "p5j8j56 _1y2v1nf2q", j = "p5j8j54", t = "p5j8j53 _1y2v1nf7p _1y2v1nf2p", e = {
    footerHeight: "var(--p5j8j50)",
    backgroundColor: "var(--p5j8j51)"
}, p = "_1y2v1nf5h";
export { v as container, a as elevated, j as fixedFooter, t as footer, e as vars, p as withoutFooter };
